import React, { useEffect }  from "react";
import { Route, Switch } from "react-router";
import "./styles/_styles.scss";
import Header from "./UI/Header/Header.jsx";
import CartPopup from "./UI/Cart/CartPopup";
import Home from "./UI/Home/Home.jsx";
import LoginAndRegisterPage from "./UI/login-and-register/LoginAndRegisterPage";
import Products from "./UI/DisplayProducts/Products";
import Single from "./UI/SingleProduct/Single";
import Checkout from "./UI/Checkout/Checkout";
export default function Routes() {


  return (
    <div className="overlay overlay--hidden">
      <Header />
      <CartPopup />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/login" component={LoginAndRegisterPage} />
        <Route exact path="/products" component={Products} />
        <Route exact path="/products/:id" component={Single} />
        <Route exact path="/checkout" component={Checkout} />
      </Switch>
    </div>
  );
}
